import { contactInfo } from '@/mocks/homeData';

export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-screen min-h-[640px] flex items-end md:items-center overflow-hidden"
    >
      {/* Fotografia full-bleed */}
      <div className="absolute inset-0">
        <img
          src="https://storage.helloreaddy.io/project_files/d597c584-8282-4ae1-8b44-377681ee7a13/6a136a40-fb12-4ea2-a6ea-0d023428f7e0_compressed_ChatGPT-Image-4-de-ago.-de-2026-16_59_37-2.webp"
          alt="Dra. Marihana Pasquali — Cirurgiã Dentista na Faria Lima, São Paulo"
          className="w-full h-full object-cover object-[70%_center]"
        />

        {/* Overlays sutis para legibilidade — mais intensos sobre o texto, suaves sobre o rosto */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/5 to-transparent"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/20 to-transparent"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/5 to-transparent"></div>
      </div>

      {/* Conteúdo */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-5 md:px-8 pt-28 md:pt-40 pb-20 md:pb-24">
        <div className="max-w-2xl">
          {/* Localização */}
          <span
            className="inline-flex items-center gap-2.5 text-white/85 text-xs md:text-sm font-medium tracking-wide mb-5 animate-fade-in-up"
            style={{ animationDelay: '0.05s' }}
          >
            <span className="w-6 h-6 flex items-center justify-center rounded-full bg-white/10 backdrop-blur-sm">
              <i className="ri-map-pin-line text-white/90 text-sm"></i>
            </span>
            Faria Lima, São Paulo
          </span>

          {/* Título principal */}
          <h1
            className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-semibold text-white leading-[1.08] tracking-tight text-balance mb-5 animate-fade-in-up"
            style={{ animationDelay: '0.15s' }}
          >
            Extração de Siso na Faria Lima
          </h1>

          {/* Subtítulo */}
          <p
            className="text-white/85 text-base md:text-xl leading-relaxed max-w-lg font-light mb-6 animate-fade-in-up"
            style={{ animationDelay: '0.25s' }}
          >
            Planejamento individualizado, segurança e acompanhamento em cada etapa do procedimento.
          </p>

          {/* Prova social */}
          <div
            className="flex flex-wrap items-center gap-x-4 gap-y-2 mb-8 animate-fade-in-up"
            style={{ animationDelay: '0.35s' }}
          >
            <span className="flex items-center gap-1.5">
              <span className="text-white/45 text-sm tracking-[0.2em]">★★★★★</span>
              <span className="text-white/65 text-sm md:text-base font-normal">4,9 no Google</span>
            </span>
            <span className="hidden sm:block w-px h-4 bg-white/20"></span>
            <span className="text-white/55 text-sm md:text-base">+43 avaliações</span>
          </div>

          {/* CTAs */}
          <div
            className="flex flex-col items-start gap-4 animate-fade-in-up"
            style={{ animationDelay: '0.45s' }}
          >
            <button
              onClick={() => scrollTo('cta')}
              className="group inline-flex items-center justify-center gap-2.5 whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-white text-base md:text-lg font-semibold px-9 md:px-11 py-4 rounded-full transition-all duration-300 cursor-pointer hover:scale-[1.02] active:scale-[0.98]"
            >
              Agendar Minha Avaliação
              <i className="ri-arrow-right-line text-lg transition-transform duration-300 group-hover:translate-x-1"></i>
            </button>

            <a
              href={`https://wa.me/${contactInfo.whatsapp}?text=Olá!%20Gostaria%20de%20agendar%20uma%20avaliação%20com%20a%20Dra.%20Marihana.`}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="group inline-flex items-center gap-3 text-white/85 hover:text-white text-sm md:text-base font-medium transition-colors duration-300 cursor-pointer animate-fade-in-up"
              style={{ animationDelay: '0.55s' }}
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-full border border-white/25 group-hover:border-white/60 group-hover:bg-white/10 transition-all duration-300">
                <i className="ri-whatsapp-line text-lg"></i>
              </span>
              Falar no WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}